import {
    NavLink
  } from "react-router-dom";
import {BsFillHouseFill,BsReverseLayoutTextSidebarReverse, BsPeople, BsBoxSeamFill,BsBoxes} from 'react-icons/bs';
import { useEffect,useState,useContext,useCallback } from "react";
import UserContext from "../../contexts/UserContext";
import { zc, central, supplier, central_zc, umaal, superadmin, superadminCity } from "../../utils/navigations";

const Footer = () => {
    const { user } = useContext(UserContext);

    const getNavigation = () => {
        if (!user) return null;
        if(user.role ==="Zone Coordinator" && user?.zone?.desc?.toLowerCase().includes("central")){
            return central_zc
        }
        switch (user.role) {
            case "Zone Coordinator":
                return zc;
            case "Purchase":
            case "CityAdmin":
                return central;
            case "Admin":
                return central;
            case "SuperAdmin":
                // superadminCity (central nav + Silat + Change Password) was added
                // for this case but never wired in - SuperAdmin lost access to
                // Silat/Change Password while inside a city. Use it now.
                return user.tenant ? superadminCity : superadmin;
            case "Supplier":
                return supplier;
            case "Umaal":
                return umaal;
            case "Logistics":
                return null;
            case "Silat Viewer":
                return null;
            default:
                return [];
        }
    };

    const navigation = getNavigation();

    const getFooterClass = () => {
        if (!user) return '';
        if(user.role ==="Zone Coordinator" && user?.zone?.desc?.toLowerCase().includes("central")){
            return 'footer zone-coordinator'
        }
        switch (user.role) {
            case "Zone Coordinator":
                return 'footer zone-coordinator';
            case "Purchase":
            case "Admin":
            case "CityAdmin":
            case "SuperAdmin":
                return 'footer central';
            case "Supplier":
                return 'footer supplier';
            case "Umaal":
                return 'footer umaal';
            default:
                return 'footer';
        }
    };

    return (
        user && navigation && (
            <div className={`flex fixed bottom-0 w-full shadow-md print-hide ${getFooterClass()}`}>
                {navigation.map((navDetails) => (
                    
                    <NavLink
                        key={navDetails.link}
                        className={({ isActive }) =>
                            isActive ? 'nav-btn active' : 'nav-btn'
                        }
                        to={navDetails.link === '/silat/commitments/edit/:id' ? `/silat/commitments/edit/${user.Mauze}` : navDetails.link === '/silat/commitments/zabihat/edit/:id'? `/silat/commitments/zabihat/edit/${user.Mauze}` : navDetails.link }
                    >
                        <div className="flex flex-col justify-center items-center">
                            <span className="nav-icon">{navDetails.icon}</span>
                            <span>{navDetails.name}</span>
                        </div>
                    </NavLink>
                ))}
            </div>
        )
    );
};

export default Footer;
